import { GetStaticProps } from 'next';
import { useEffect } from 'react';
import { IPricing } from '../../../../components/S/pricing/types';
import { getObjectByKey } from '../../../../components/S/pricing/utils';
import {
  PARTNER_META_KEY,
  PRICING_META_KEY,
} from '../../../../components/partner-pages/constants';
import PartnerPageDataService from '../../../../components/partner-pages/services/partner-pages.service';
import { FM_ACTIONS, returnNoProps } from '../../../../utils/UtilFunctions';
import { staticPropsWrapper } from '../../../../utils/static-pages/utils';
import { handleTrack } from '../../../../utils/tracker';
import { NewPricingPage } from '../../../../components/S/pricing/components/pricing-v1/pricing-card-v1';

const Pricing: React.FC<IPricing> = (props) => {
  useEffect(() => {
    if (window.location.href.includes('/s/pricing')) {
      sessionStorage.setItem('/s/pricing', `mp_pricing_new`);
    }

    handleTrack({
      label: 'pricing-page-new',
      action: FM_ACTIONS.pageview,
    });
  }, []);

  return <NewPricingPage {...props} />;
};

export const getStaticProps: GetStaticProps = staticPropsWrapper(
  __filename,
  async () => {
    try {
      const resMeta = await PartnerPageDataService.getMetaDataMulti(
        [PARTNER_META_KEY, PRICING_META_KEY].join(',')
      );
      let responseDataMeta;
      if (resMeta.data) {
        responseDataMeta = resMeta.data;
        return {
          props: {
            pricePageData: getObjectByKey(responseDataMeta, PRICING_META_KEY),
            metaData: getObjectByKey(responseDataMeta, PARTNER_META_KEY),
          },
        };
      }
    } catch (error) {
      return returnNoProps();
    }
    return returnNoProps();
  }
);

export default Pricing;
